var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocumentCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M89.142 34.1423C92.0325 37.0326 93.4775 38.4777 94.239 40.3154C95 42.1531 95 44.1969 95 48.2844V85.0001C95 94.4281 95 99.1421 92.071 102.071C89.142 105 84.428 105 75 105H45C35.5719 105 30.8579 105 27.929 102.071C25 99.1421 25 94.4281 25 85.0001V35.0001C25 25.572 25 20.858 27.929 17.9291C30.8579 15.0001 35.5719 15.0001 45 15.0001H61.7155C65.803 15.0001 67.847 15.0001 69.6845 15.7613C71.5225 16.5225 72.9675 17.9677 75.858 20.858L89.142 34.1423Z",
    fill: "#E0BA56"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M89.142 34.1423C92.0325 37.0326 93.4775 38.4777 94.239 40.3154C95 42.1531 95 44.1969 95 48.2844V85.0001C95 94.4281 95 99.1421 92.071 102.071C89.142 105 84.428 105 75 105H45C35.5719 105 30.8579 105 27.929 102.071C25 99.1421 25 94.4281 25 85.0001V35.0001C25 25.572 25 20.858 27.929 17.9291C30.8579 15.0001 35.5719 15.0001 45 15.0001H61.7155C65.803 15.0001 67.847 15.0001 69.6845 15.7613C71.5225 16.5225 72.9675 17.9677 75.858 20.858L89.142 34.1423Z",
    stroke: "#E0BA56",
    strokeWidth: 5,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M45 70.0001L52.886 77.8861C54.0535 79.0536 55.9465 79.0536 57.114 77.8861L75 60.0001",
    stroke: "#E0BA56",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentCheck);
export default __webpack_public_path__ + "static/media/document-check.8668bae83002a1c1ae15753b22c58edc.svg";
export { ForwardRef as ReactComponent };